var map = {
	"./ls-ehs-losses.svg": 1402,
	"./ls-finance-data.svg": 1403,
	"./ls-it-losses.svg": 1404,
	"./ls-line-efficiency-losses.svg": 1405,
	"./ls-maintenance-losses.svg": 1406,
	"./ls-operator-effort-losses.svg": 1407,
	"./ls-quality-losses.svg": 1408,
	"./ls-warehouse-losses.svg": 1409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 659;